module.exports = __webpack_public_path__ + "img/retail.39017785.jpg";